// Photos uploaded into post/comment text: `/<park>/chat_images/<name>` on
// mousewait.com (absolute or relative). Main post images use other markup.
const UPLOADED_PHOTO_SRC_RE =
  /(\ssrc\s*=\s*["'](?:https?:\/\/(?:www\.)?mousewait\.com)?\/(?:disneyland|disneyworld)\/chat_images)(\/[^"'/?#]+\.(?:jpe?g|png|gif|webp)["'])/i;

/**
 * Photos embedded in post/comment HTML are stored at full camera size
 * (often 2-7 MB).
 * - Uploaded photos load from `chat_images_web`, a copy the Cloudflare Worker
 *   scales to 1600px WebP (the Worker serves the original if it can't).
 * - `loading="lazy"` and `decoding="async"` are added to <img> tags that
 *   don't already set them, so off-screen photos wait until scrolled to.
 * Everything else in the HTML is left as-is.
 */
export const lazyLoadHtmlImages = (html: string): string => {
  if (!html || !html.includes('<img')) return html;

  return html.replace(/<img\b([^>]*?)(\/?)>/gi, (tag, attrs: string, selfClose: string) => {
    let nextAttrs = attrs.replace(UPLOADED_PHOTO_SRC_RE, '$1_web$2');
    if (!/\sloading\s*=/i.test(nextAttrs)) nextAttrs += ' loading="lazy"';
    if (!/\sdecoding\s*=/i.test(nextAttrs)) nextAttrs += ' decoding="async"';
    return `<img${nextAttrs}${selfClose}>`;
  });
};
